/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_Remove_Font_LabelInputs */



/**
* | output |
* | --- |
* | "Remove Font" |
*
* @param {Options_Fonts_Remove_Font_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_remove_font_label = /** @type {((inputs?: Options_Fonts_Remove_Font_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_Remove_Font_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la police")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schriftart entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi carattere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить шрифт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除字体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォントを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ॉन्ट हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover fonte")
	return /** @type {LocalizedString} */ ("Remove Font")
});